// eslint-disable-next-line import/prefer-default-export
export const convertPxToTailwindMarginLeft = (pxValue: string): string => {
  const pxToTailwind: Record<string, string> = {
    '4px': 'ml-1',
    '8px': 'ml-2',
    '12px': 'ml-3',
    '16px (default)': 'ml-4',
    '20px': 'ml-5',
    '24px': 'ml-6',
    '28px': 'ml-7',
    '32px': 'ml-8',
  };

  return pxToTailwind[pxValue] || '';
};
